import cookieReader from 'js-cookie';
import { getUrlCurrentLocaleCodes } from '@xarvio/frontend-core-platform/lib/country/CountryUtils';
import {
  LocalStorageKey,
  LocalStorageUtil,
} from '@xarvio/frontend-core-platform/lib/storage';
import { getPagesUrl } from '@xarvio/frontend-core-platform/lib/routerUrls';
import { splitLocale } from '../../intl/utils';

interface LogoutProps {
  locale?: string;
  redirectPath?: string;
  useHardRedirect?: boolean;
}

export const logout = ({
  locale: localeParent,
  redirectPath,
  useHardRedirect: useHardRedirectParent,
}: LogoutProps): string | undefined => {
  const locale = localeParent ?? getUrlCurrentLocaleCodes().locale;
  const { country } = splitLocale(locale);
  const useHardRedirect = useHardRedirectParent ?? true;

  LocalStorageUtil.remove(LocalStorageKey.CFD_FILTER_STATE);
  LocalStorageUtil.remove(LocalStorageKey.CUSTOM_MAP_CREATION_INTRO_VIEWED);
  LocalStorageUtil.remove(LocalStorageKey.PREFECTURE_SELECTION_MODAL_SHOWN);
  LocalStorageUtil.remove(LocalStorageKey.NEW_UNPROCESSED_MAPS_TOAST_VIEWED);
  LocalStorageUtil.remove(LocalStorageKey.ONBOARDING_SMART_SPRAYER);
  LocalStorageUtil.remove(LocalStorageKey.UPDATE_PAYMENT_DETAILS_TOAST_VIEWED);
  LocalStorageUtil.remove(
    LocalStorageKey.BARILLA_INITIAL_ONBOARDING_IN_PROGRESS,
  );
  LocalStorageUtil.remove(
    LocalStorageKey.PERONI_INITIAL_ONBOARDING_IN_PROGRESS,
  );

  cookieReader.remove(import.meta.env.VITE_SECURITY_TOKEN_NAME, {
    domain: import.meta.env.VITE_TOKEN_DOMAIN,
  });
  cookieReader.remove(import.meta.env.VITE_GIGYA_LOGIN_TOKEN_NAME, {
    domain: import.meta.env.VITE_TOKEN_DOMAIN,
  });

  const { loginPageUrl } = getPagesUrl({
    locale,
    country,
  });

  if (redirectPath) {
    // Legacy behavior (kept for safety):
    // window.location.replace(redirectPath);
    if (useHardRedirect) {
      window.location.replace(redirectPath);
      return undefined;
    }

    return redirectPath;
  } else {
    // Legacy behavior (kept for safety):
    // window.location.href = loginPageUrl;
    if (useHardRedirect) {
      window.location.href = loginPageUrl;
      return undefined;
    }

    return loginPageUrl;
  }
};
